import { memo, useState } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import FormControl from '@zenbusiness/zui/FormControl';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Radio from '@zenbusiness/zui/Radio';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { EMPLOYEES_ANSWER } from './constants/employees';

const EmployUIField = ({
  field = { setSaved: () => {}, setLoading: () => {} },
  value = '',
  dataChangeHandler = () => {},
  disabled
}) => {
  const [employees, setEmployees] = useState(value || '');
  const trackEmployChangeClick = useClickstreamCallback('buttonPressed');

  const handleEmployeesChange = (event, selectedValue) => {
    if (selectedValue) {
      field.setLoading();
    }

    // Tracking Details: Tracking added to employees question
    trackEmployChangeClick({
      elementText: event?.target?.name,
      elementName: 'banking_collect_info',
      appPageName: 'banking_application'
    });
    setEmployees(selectedValue);
    dataChangeHandler(
      selectedValue,
      { numberOfEmployees: selectedValue },
      (forceUpdate, { isSave, isError }) => {
        field.setSaved(isSave, isError);
        forceUpdate();
      }
    );
  };

  const employList = EMPLOYEES_ANSWER.map(({ label, key }) => (
    <FormControlLabel
      control={<Radio aria-label="employ option" />}
      key={label}
      label={<Text size="xl">{label}</Text>}
      name={label}
      sx={{
        width: 'max-content'
      }}
      value={key}
    />
  ));

  return (
    <Stack spacing="16px">
      <FormControl disabled={disabled}>
        <RadioGroup
          name="numberOfEmployees"
          onChange={handleEmployeesChange}
          sx={{ gap: '16px' }}
          value={employees}
        >
          {employList}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
};

EmployUIField.propTypes = {
  value: PropTypes.string,
  dataChangeHandler: PropTypes.func,
  field: PropTypes.shape({
    setSaved: PropTypes.func,
    setLoading: PropTypes.func
  }),
  disabled: PropTypes.bool
};

function areEqual(preProp, nextProp) {
  return (
    preProp.field === nextProp.field &&
    preProp.value === nextProp.value &&
    preProp.disabled === nextProp.disabled
  );
}

export default memo(EmployUIField, areEqual);
